<template>
  <bk-bets-list :data-func="getBets" :show-user="true" />
</template>
<script>
  import bkService from '../../../services/bk.service'

  import bkBetsList from '../../common/bk-bets-list.vue'

  export default {
    name: 'client-bk-bets',
    components: { bkBetsList },
    methods: {
      async getBets(filter) {
        return await bkService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/bets/bk-bets.vue